import { createClient } from '@supabase/supabase-js';

// 公開して問題のない値（URL と Publishable key）だけを使う。
// これらはブラウザに必ず含まれる公開値なので、コードに直接書いても安全。
// Gemini APIキーやservice_role/secret key は Edge Function 側にしか存在しない。
// ※環境変数があればそちらを優先し、無ければ下の既定値を使う（＝デプロイ先で変数設定が不要）。
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://cmwwocfdgkfgutiwlnhx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || "sb_publishable_ga2637wuhrVtnF8J1HrwKQ_NZTaSIqV";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
